/**
 * The step-by-step offer as the footer band of the "Helpful suggestions" card
 * (Documentation/specs/2026-10-22-v5-banner-design.md, Option A, owner's choice).
 *
 * Behaviour is frozen: one button, the click sends the server's own label through onSelect(label),
 * exactly as the old list item did. Only the markup and states change: icon circle, bold label, one
 * muted line of explanation, trailing chevron; accepted shows a check (aria-pressed), declined (another
 * option picked) dims it, streaming disables it. Test anchor kept: .d5-followup-option-guided.
 * Compact layout (owner, 23 Oct): one slim line, caption inline and truncated by CSS.
 */
import React from "react";
import { Check, ChevronRight, ListChecks } from "lucide-react";

export const GUIDED_OFFER_SUBLINE = "Guided diagnostic: Arta asks, you confirm each step.";
export const OFFER_STATES = Object.freeze({ IDLE: "idle", ACCEPTED: "accepted", DECLINED: "declined" });
const ICON_SIZE = 12;

export default function GuidedOfferRow({ label, subId, offerState = OFFER_STATES.IDLE, disabled = false, onSelect }) {
  const accepted = offerState === OFFER_STATES.ACCEPTED;
  return (
    <button
      type="button"
      className={`d5-followup-option d5-followup-option-guided d5-offer-row d5-offer-row--${offerState}`}
      disabled={disabled || offerState !== OFFER_STATES.IDLE}
      aria-pressed={accepted}
      aria-describedby={subId}
      title="Switch to the diagnostic step-by-step walkthrough"
      onClick={() => onSelect?.(label)}
    >
      <span className="d5-offer-icon" aria-hidden="true"><ListChecks size={ICON_SIZE} /></span>
      <span className="d5-offer-body">
        <span className="d5-followup-text d5-offer-label">{label}</span>
        <span id={subId} className="d5-offer-sub">{GUIDED_OFFER_SUBLINE}</span>
      </span>
      <span className="d5-offer-trail" aria-hidden="true">
        {accepted ? <Check size={ICON_SIZE} /> : <ChevronRight size={ICON_SIZE} />}
      </span>
    </button>
  );
}
